import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import { scrollBehavior } from './utils'
// import { dispatchAction, addGA } from './hooks'
import routes from './routes'
import store from '@/store'
import tdealApi from '@/api/tdealApi'
import tdealApiV2 from '@/api/tdealApiV2'
Vue.use(Router)
Vue.use(Meta)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  scrollBehavior,
  routes
})

// router.beforeEach(dispatchAction)
// router.afterEach(addGA)

export default router
